export function safeJSONparse(str: string, isDevelopment?: boolean): object | false;
export function safeJSONparse<T = object>(str: string, isDevelopment?: boolean): T;
export function safeJSONparse<T = object>(str: string, isDevelopment?: boolean): T | false {
  if (!str) {
    return false;
  }

  try {
    const parsed = JSON.parse(str);

    if (parsed && typeof parsed === "object") {
      return parsed as T;
    }
  } catch (e) {
    if (isDevelopment) {
      console.error(e);
    }
  }

  return false;
}
